import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useInViewReveal } from "@/hooks/useInViewReveal";

export const TestimonialSection = () => {
  const [t] = useTranslation("homeowners");
  const { ref: sectionRef, hasRevealed } = useInViewReveal({ threshold: 0.3 });

  return (
    <section
      ref={sectionRef}
      className="w-full bg-[#4f4f4b] px-6 sm:px-12 lg:px-40 py-16 lg:py-32 text-center text-white"
    >
      <blockquote
        className={classNames(
          "flex flex-col items-center gap-10 lg:gap-16 transition-all duration-[280ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
          {
            "opacity-100 translate-y-0": hasRevealed,
            "opacity-0 translate-y-[12px]": !hasRevealed,
          }
        )}
      >
        <p className="font-minion italic text-[clamp(1.25rem,0.8rem+1.8vw,3rem)] leading-snug">
          {t("Testimonial.Quote")}
        </p>
        <cite
          className={classNames(
            "font-montserrat font-medium not-italic text-[clamp(0.875rem,0.7rem+0.6vw,1.75rem)] transition-all duration-[280ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] delay-[100ms]",
            {
              "opacity-100 translate-y-0": hasRevealed,
              "opacity-0 translate-y-[12px]": !hasRevealed,
            }
          )}
        >
          {t("Testimonial.Author")}
        </cite>
      </blockquote>
    </section>
  );
};
